import React, { useContext } from "react";
import "./FloatingProcessStatusCard.scss";
import { Box, Button, IconButton, Paper, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ProcessStatusLoading } from "../../Loadings/ProcessStatusLoading/ProcessStatusLoading";
import { RecommendationsAPIContext } from "../../../../context/RecommendationsAPI/recommendationsAPIContext";
import { RECOMMENDATION_API_CONSTANTS } from "../../../../context/RecommendationsAPI/constants";

export function FloatingProcessStatusCard({ handleOnComplete }) {
  const { processData, setShowProcessStatusCard } = useContext(
    RecommendationsAPIContext
  );

  const processErrorMessage = (
    <>
      <p style={{ marginBottom: "12px" }}>
        Não foi possível ler o arquivo selecionado. Verifique-o e tente
        novamente.
      </p>

      <p>
        {`Caso o problema persista, entre em contato com suporte e reporte o código: `}
        <span
          style={{ color: "#7F808E" }}
        >{`${processData?.xCorrelationId}`}</span>
      </p>
    </>
  );

  return (
    <div className="floating-process-status-card-container">
      <Paper
        elevation={2}
        sx={{
          backgroundColor: "#FFF",
          padding: "24px",
          borderRadius: "4px",
          minWidth: "420px",
          maxWidth: "550px",
          minHeight: "100px",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        {processData?.status ===
          RECOMMENDATION_API_CONSTANTS.TASK_STATUS_PENDING && (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "16px",
              }}
            >
              <Typography
                sx={{
                  color: "#B03EFA",
                  fontSize: "16px",
                  fontWeight: 900,
                  fontFamily: "inherit",
                  textAlign: "center",
                  marginRight: "16px",
                }}
              >
                Lendo arquivo
              </Typography>

              <ProcessStatusLoading />
            </Box>

            <Typography
              sx={{
                color: "#A9AAB8",
                fontSize: "12px",
                fontFamily: "inherit",
                textAlign: "left",
                marginBottom: "24px",
                maxWidth: "300px",
              }}
            >
              {`${
                processData?.data?.fileName || processData?.taskData?.fileName
              }`}
            </Typography>
          </>
        )}

        {processData?.status ===
          RECOMMENDATION_API_CONSTANTS.TASK_STATUS_COMPLETE && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
              }}
            >
              <Typography
                sx={{
                  color: "#36355A",
                  fontSize: "16px",
                  fontWeight: 900,
                  fontFamily: "inherit",
                  textAlign: "center",
                  marginRight: "16px",
                  marginBottom: "12px",
                }}
              >
                Leitura completa.
              </Typography>

              <Typography
                sx={{
                  color: "#A9AAB8",
                  fontSize: "12px",
                  fontFamily: "inherit",
                  textAlign: "left",
                  paddingRight: "24px",
                }}
              >
                {`${
                  processData?.data?.fileName || processData?.taskData?.fileName
                }`}
              </Typography>
            </Box>

            <Button
              onClick={handleOnComplete}
              disabled={false}
              sx={{
                alignItems: "center",
                padding: "8px 24px",
                borderRadius: "4px",
                backgroundColor: "#B03EFA",
                color: "#FFF",
                fontSize: "16px",
                textTransform: "none",
                transition: "all 200ms ease-in-out",
                minWidth: "160px",
                fontFamily: "inherit",
                fontWeight: 700,
                marginLeft: "auto",
                whiteSpace: "nowrap",

                "&:hover": {
                  backgroundColor: "rgba(179, 102, 255, 0.3)",
                  borderColor: "#9B4FD6",
                },

                "&:active": {
                  backgroundColor: "rgba(179, 102, 255, 0.15)",
                },

                "&:disabled": {
                  opacity: 0.5,
                  cursor: "not-allowed",
                },

                "&:focus-visible": {
                  outline: "none",
                  boxShadow: "0 0 0 4px rgba(179, 102, 255, 0.18)",
                },
              }}
            >
              Abrir resultado
            </Button>
          </Box>
        )}

        {processData?.status ===
          RECOMMENDATION_API_CONSTANTS.TASK_STATUS_FAILED && (
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                }}
              >
                <Typography
                  sx={{
                    color: "#EC1045",
                    fontSize: "16px",
                    fontWeight: 900,
                    fontFamily: "inherit",
                    textAlign: "center",
                    marginRight: "16px",
                    marginBottom: "12px",
                  }}
                >
                  Leitura incompleta.
                </Typography>

                <Typography
                  sx={{
                    color: "#A9AAB8",
                    fontSize: "12px",
                    fontFamily: "inherit",
                    textAlign: "left",
                    marginBottom: "24px",
                    paddingRight: "24px",
                  }}
                >
                  {`${
                    processData?.data?.fileName ||
                    processData?.taskData?.fileName
                  }`}
                </Typography>
              </Box>

              <IconButton
                aria-label="close"
                onClick={() => setShowProcessStatusCard(false)}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <Box>
              <Typography
                sx={{
                  color: "#36355A",
                  fontSize: "12px",
                  fontFamily: "inherit",
                  textAlign: "left",
                  marginTop: "6px",
                }}
              >
                {processErrorMessage}
              </Typography>
            </Box>
          </Box>
        )}
      </Paper>
    </div>
  );
}
